<div class="reaction-picker" *ngIf="!full; else everyEmoji" role="group" aria-label="React" (keydown)="onKeydown($event)">
    <button type="button" class="reaction-picker-key" *ngFor="let choice of choices"
            (click)="picked.emit(choice.glyph)" [matTooltip]="choice.name" [attr.aria-label]="choice.name">
        {{choice.glyph}}
    </button>
    <!-- B-10 (ITP-E-207-04): any emoji, from the composer's emoji picker, in this bar's place. -->
    <button type="button" class="reaction-picker-key reaction-picker-more" *ngIf="anyEmoji" (click)="more.emit()"
            matTooltip="More reactions" aria-label="More reactions">
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
    </button>
</div>
<ng-template #everyEmoji>
    <div class="reaction-picker-full" role="group" aria-label="React">
        <emoji-mart class="reaction-picker-any" [isNative]="true" [showPreview]="false" [perLine]="7" [exclude]="['flags']"
                    [darkMode]="false" title="Pick a reaction" (emojiSelect)="picked.emit($event.emoji.native)"></emoji-mart>
    </div>
</ng-template>
